import { render } from "./form_1.vue?vue&type=template&id=fe870e90"
import script from "./form_1.vue?vue&type=script&lang=js"
export * from "./form_1.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe870e90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe870e90', __exports__)) {
    console.log('reload')
    api.reload('fe870e90', __exports__)
  }
  
  module.hot.accept("./form_1.vue?vue&type=template&id=fe870e90", () => {
    console.log('re-render')
    api.rerender('fe870e90', render)
  })

}


export default __exports__